import { useMemo } from 'react'

import { selectInsight } from './selectInsight'
import type { InsightInput, InsightResult } from './selectInsight'

export type UseInsightMessageOptions = InsightInput

/**
 * Derives a short data-driven insight message for the current narrative view.
 * Returns `{ message: string | null, isPositive: boolean }`.
 *
 * All selection logic lives in the pure {@link selectInsight}; this hook only
 * memoizes it so the result is stable between renders with the same inputs.
 */
export function useInsightMessage(options: InsightInput): InsightResult {
  const {
    visibleMetrics,
    viewMode,
    selectedView,
    singleMetricKey,
    isBenchmarkView,
    benchmarkChannelRate,
    benchmarkMedianRate,
    loading,
    error,
    isInactive,
  } = options

  return useMemo(
    () =>
      selectInsight({
        visibleMetrics,
        viewMode,
        selectedView,
        singleMetricKey,
        isBenchmarkView,
        benchmarkChannelRate,
        benchmarkMedianRate,
        loading,
        error,
        isInactive,
      }),
    [
      visibleMetrics,
      viewMode,
      selectedView,
      singleMetricKey,
      isBenchmarkView,
      benchmarkChannelRate,
      benchmarkMedianRate,
      loading,
      error,
      isInactive,
    ],
  )
}
